import { formatJsonDataset as fjd } from "../../components/renderers";

export const formsconfig = {

  prompt: {
    service: {
      name: 'prompt',
      title: 'AI Prompts',
      num: true,
      fields: ['rid','nam','shc','dsc','ptx','ver','sts','ast','stp'],
      grid: [
        ['nam','Name'],
        ['shc','Code'],
        ['ver','Version'],
        ['dsc','Description'],
        ['ptx','Prompt Text'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Name', v:'nam' },
          { t:'Code', v:'shc' }
        ],
        def:'nam'
      },
      eform: [
        { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
        { id:'shc', label:'Code', type:'tf', req:1, ops:{} },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'ptx', label:'Prompt Text', type:'ta', req:1, ops:{} },
        { id:'ver', label:'Version', type:'nf', req:1, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: {}
  },

  requisition: {
    service: {
      name: 'requisition',
      title: 'Requisitions',
      num: true,
      fields: [
        'rid','nam','shc','rti','rtn','rtc','bpi','bpn','bpc','bci','bcn','bcc','cci','ccn','ccc',
        'sfi','sfn','sfc','rsi','rsn','rsc','rfn','pps','rqd','nfr','nto','tes','aia','raw',
        'edi','edn','edc','dcd','exi','sts','ast','stp'
      ],
      grid: [
        ['nam','Name'],
        ['shc','Code'],
        ['rtn','Type'],
        ['bpn','Period'],
        ['bcn','Cycle'],
        ['ccn','Cost Center'],
        ['sfn','Staff'],
        ['rsn','State'],
        ['rfn','Reference'],
        ['pps','Purpose'],
        ['rqd','Requested'],
        ['tes','Estimate'],
        ['aia','AI Assisted'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Name', v:'nam' },
          { t:'Reference', v:'rfn' },
          { t:'Purpose', v:'pps' }
        ],
        def:'nam'
      },
      eform: [
        { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
        { id:'shc', label:'Code', type:'tf', req:1, ops:{} },
        { id:'rti', label:'Type', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'requisitiontype' } },
        { id:'bpi', label:'Period', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'budgetperiod' } },
        { id:'bci', label:'Cycle', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'budgetcycle' } },
        { id:'cci', label:'Cost Center', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'costcenter' } },
        { id:'sfi', label:'Staff', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'staff' } },
        { id:'rsi', label:'State', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'requisitionstate' } },
        { id:'rfn', label:'Reference', type:'tf', req:1, ops:{} },
        { id:'pps', label:'Purpose', type:'ta', req:0, ops:{} },
        { id:'rqd', label:'Requested Date', type:'df', req:1, ops:{} },
        { id:'nfr', label:'Needed From', type:'df', req:1, ops:{} },
        { id:'nto', label:'Needed To', type:'df', req:0, ops:{} },
        { id:'tes', label:'Total Estimate', type:'nf', req:0, ops:{} },
        { id:'aia', label:'AI Assisted', type:'cb', req:0, ops:{} },
        { id:'raw', label:'Raw Input', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd, raw:fjd } }
  },

  requisitionitem: {
    service: {
      name: 'requisitionitem',
      title: 'Requisition Items',
      num: true,
      fields: [
        'rid','nam','shc','rqi','rqn','rqc','lno','iti','itn','itc','qty','umi','umn','umc',
        'ues','tes','nfr','nto','jus','eoc','tsp','pri','prn','prc','isi','isn','isc',
        'kpn','edi','edn','edc','dcd','exi','sts','ast','stp'
      ],
      grid: [
        ['rqn','Requisition'],
        ['lno','Line No'],
        ['nam','Name'],
        ['shc','Code'],
        ['itn','Type'],
        ['qty','Quantity'],
        ['umn','UOM'],
        ['ues','Unit Estimate'],
        ['tes','Total Estimate'],
        ['prn','Priority'],
        ['isn','State'],
        ['kpn','KPI Note'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Name', v:'nam' },
          { t:'Code', v:'shc' },
          { t:'Requisition', v:'rqn' }
        ],
        def:'nam'
      },
      eform: [
        { id:'rqi', label:'Requisition', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'requisition' } },
        { id:'lno', label:'Line No', type:'nf', req:1, ops:{} },
        { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
        { id:'shc', label:'Code', type:'tf', req:1, ops:{} },
        { id:'iti', label:'Type', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'resourcetype' } },
        { id:'qty', label:'Quantity', type:'nf', req:1, ops:{} },
        { id:'umi', label:'UOM', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'uom' } },
        { id:'ues', label:'Unit Estimate', type:'nf', req:0, ops:{} },
        { id:'tes', label:'Total Estimate', type:'nf', req:0, ops:{} },
        { id:'nfr', label:'Needed From', type:'df', req:1, ops:{} },
        { id:'nto', label:'Needed To', type:'df', req:0, ops:{} },
        { id:'jus', label:'Justification', type:'ta', req:0, ops:{} },
        { id:'eoc', label:'Expected Outcome', type:'ta', req:0, ops:{} },
        { id:'tsp', label:'Technical Spec', type:'ta', req:0, ops:{} },
        { id:'pri', label:'Priority', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'priority' } },
        { id:'isi', label:'State', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'requisitionitemstate' } },
        { id:'kpn', label:'KPI Note', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  requisitionfile: {
    service: {
      name: 'requisitionfile',
      title: 'Requisition Files',
      num: true,
      fields: [
        'rid','nam','shc','rqi','rqn','rqc','rii','rin','ric','fln','fty','fsz','sky',
        'edi','edn','edc','dsc','dcd','exi','sts','ast','stp'
      ],
      grid: [
        ['nam','Name'],
        ['shc','Code'],
        ['rqn','Requisition'],
        ['rin','Item'],
        ['fln','Filename'],
        ['fty','File Type'],
        ['fsz','File Size'],
        ['sky','Storage Key'],
        ['dsc','Description'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Name', v:'nam' },
          { t:'Filename', v:'fln' },
          { t:'Requisition', v:'rqn' }
        ],
        def:'nam'
      },
      eform: [
        { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
        { id:'shc', label:'Code', type:'tf', req:1, ops:{} },
        { id:'rqi', label:'Requisition', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'requisition' } },
        { id:'rii', label:'Item', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'requisitionitem' } },
        { id:'fln', label:'Filename', type:'tf', req:1, ops:{} },
        { id:'fty', label:'File Type', type:'tf', req:0, ops:{} },
        { id:'fsz', label:'File Size', type:'nf', req:0, ops:{} },
        { id:'sky', label:'Storage Key', type:'tf', req:1, ops:{} },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  itemlink: {
    service: {
      name: 'itemlink',
      title: 'Item Links',
      num: true,
      fields: [
        'rid','rii','rin','ric','lii','lin','lic','amt','rmk','edi','edn','edc','dcd','exi','sts','ast','stp'
      ],
      grid: [
        ['rin','Item'],
        ['lin','Line Item'],
        ['amt','Amount'],
        ['rmk','Remarks'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Item', v:'rin' },
          { t:'Line Item', v:'lin' }
        ],
        def:'rin'
      },
      eform: [
        { id:'rii', label:'Item', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'requisitionitem' } },
        { id:'lii', label:'Line Item', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'lineitem' } },
        { id:'amt', label:'Amount', type:'nf', req:1, ops:{} },
        { id:'rmk', label:'Remarks', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  itemreview: {
    service: {
      name: 'itemreview',
      title: 'Item Reviews',
      num: true,
      fields: [
        'rid','aci','acn','acc','rii','rin','ric','cai','can','cac','cci','ccn','ccc','amt',
        'rmk','ais','rsi','rsn','rsc','edi','edn','edc','dcd','exi','sts','ast','stp'
      ],
      grid: [
        ['acn','Activity'],
        ['rin','Item'],
        ['can','Account'],
        ['ccn','Cost Center'],
        ['amt','Amount'],
        ['ais','AI Suggested'],
        ['rsn','State'],
        ['rmk','Remarks'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Item', v:'rin' },
          { t:'Account', v:'can' },
          { t:'Activity', v:'acn' }
        ],
        def:'rin'
      },
      eform: [
        { id:'aci', label:'Activity', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'activity' } },
        { id:'rii', label:'Item', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'requisitionitem' } },
        { id:'cai', label:'Account', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'chartofaccounts' } },
        { id:'cci', label:'Cost Center', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'costcenter' } },
        { id:'amt', label:'Amount', type:'nf', req:1, ops:{} },
        { id:'rmk', label:'Remarks', type:'ta', req:0, ops:{} },
        { id:'ais', label:'AI Suggested', type:'cb', req:0, ops:{} },
        { id:'rsi', label:'State', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'reviewstate' } },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  aiextract: {
    service: {
      name: 'aiextract',
      title: 'AI Extracts',
      num: true,
      fields: [
        'rid','rqi','rqn','rqc','pti','ptn','ptc','raw','sop','cfv','mdn','rmk','edi','edn','edc','dcd','exi','sts','ast','stp'
      ],
      grid: [
        ['rqn','Requisition'],
        ['ptn','Prompt'],
        ['cfv','Confidence'],
        ['mdn','Model'],
        ['rmk','Remarks'],
        ['sop','Structured Output'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Requisition', v:'rqn' },
          { t:'Prompt', v:'ptn' },
          { t:'Model', v:'mdn' }
        ],
        def:'rqn'
      },
      eform: [
        { id:'rqi', label:'Requisition', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'requisition' } },
        { id:'pti', label:'Prompt', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'prompt' } },
        { id:'raw', label:'Raw Input', type:'ta', req:0, ops:{} },
        { id:'sop', label:'Structured Output', type:'jf', req:0, ops:{} },
        { id:'cfv', label:'Confidence', type:'nf', req:0, ops:{} },
        { id:'mdn', label:'Model Name', type:'tf', req:0, ops:{} },
        { id:'rmk', label:'Remarks', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd, sop:fjd } }
  },

};